module.exports = __webpack_public_path__ + "static/media/dreamlagoonsara.492d84fc.jpg";